import { KENSUKE_FEATURE_CARD_DEFS } from '../constants/kensukeFeatureCards';

/** app_surface → i18n キー（アクセスログ集計表示用） */
export const ACCESS_LOG_APP_SURFACE_LABEL_KEYS: Record<string, string> = {
  home: 'access_logs.path.top',
  auth: 'access_logs.app.auth',
  oauth: 'access_logs.app.oauth',
  dashboard: 'dashboard.title',
  billing: 'access_logs.app.billing',
  profile: 'access_logs.app.profile',
  help: 'access_logs.path.help',
  contact: 'access_logs.path.contact',
  legal: 'access_logs.app.legal',
  usage_record: 'access_logs.app.usage_record',
  feature_requests: 'access_logs.app.feature_requests',
  keisuke: 'access_logs.path.keisuke',
  gaisuke: 'access_logs.path.gaisuke',
  gaisuke_admin: 'access_logs.app.gaisuke_admin',
  keiba_arena: 'access_logs.path.keiba_arena',
  banquet: 'access_logs.path.banquet',
  econ_report: 'access_logs.path.econ_report',
  labo_suke: 'access_logs.path.labo_suke',
  transit_pass: 'access_logs.path.transit_pass',
  gene_analysis: 'access_logs.path.gene_analysis',
  reservation: 'access_logs.path.reservation_demo',
  sample: 'access_logs.path.samples',
  sample_public_share: 'access_logs.app.sample_public_share',
  admin: 'access_logs.app.admin',
  admin_access_logs: 'access_logs.title',
  admin_conversion: 'conversion_funnel.title',
  admin_user_activity: 'access_logs.app.admin_user_activity',
  admin_database: 'access_logs.app.admin_database',
  admin_users: 'access_logs.app.admin_users',
  error: 'access_logs.app.error',
};

export function labelForAppSurface(
  appSurface: string | null | undefined,
  t: (key: string, options?: { defaultValue?: string }) => string
): string {
  if (!appSurface) return '-';
  const feature = KENSUKE_FEATURE_CARD_DEFS.find((d) => d.id === appSurface);
  if (feature) {
    return t(feature.titleKey, { defaultValue: appSurface });
  }
  const key = ACCESS_LOG_APP_SURFACE_LABEL_KEYS[appSurface];
  if (key) {
    return t(key, { defaultValue: appSurface });
  }
  return appSurface;
}
